module.exports = __webpack_public_path__ + "static/img/IMG_20241030_141612.ad358ac9.jpg";